module.exports = "<electra-sub-page-header \t[text]=\"'About'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t(close)=\"closeClick()\">\n</electra-sub-page-header>\n<img id=\"award\" src=\"assets/award.svg\" />\n<img id=\"brand-logo\" src=\"assets/powermap_no icon.svg\"/>\n<img id=\"about-logo\" src=\"assets/powered_by.svg\"/>\n<span id=\"version\">\n  Version {{config.version}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/about/about.component.html
// module id = 420
// module chunks = 1